const FaqDrawerConstants = {
  mostCommonQuestions: 'Most Common Questions',
  allCategories: 'All Categories',
  moreInfo: 'More Info',
  moreQuestions: 'More Questions?',
  contactUs: 'Contact Us'
};

export { FaqDrawerConstants };